var _g, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 881,
    viewBox: "0 0 854 881",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_if_8_55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M843.612 416.224L661.271 279.042C624.837 251.631 592.324 219.366 564.635 183.144L427.133 3.26761L252.704 228.166C263.804 272.342 309.223 373.207 417.675 387.754C450.209 392.127 504.14 395.804 592.319 372.386C593.3 372.208 594.282 372.083 595.263 371.922C608.005 385.291 634.311 442.105 705.464 472.537C742.941 486.531 765.374 472.752 789.002 456.009L843.612 416.224Z",
    fill: "#0E77F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.612 416.224L661.271 279.042C624.837 251.631 592.324 219.366 564.635 183.144L427.133 3.26761L252.704 228.166C263.804 272.342 309.223 373.207 417.675 387.754C450.209 392.127 504.14 395.804 592.319 372.386C593.3 372.208 594.282 372.083 595.263 371.922C608.005 385.291 634.311 442.105 705.464 472.537C742.941 486.531 765.374 472.752 789.002 456.009L843.612 416.224Z",
    fill: "url(#paint0_linear_8_55)"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_df_8_55)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M592.319 372.083C626.673 365.639 663.186 372.904 684.976 381.007C697.861 386.166 752.792 406.924 788.878 455.724L843.612 415.885L661.239 278.648C624.861 251.273 592.393 219.059 564.734 182.898L427.133 3L252.704 227.898C263.804 272.075 309.223 372.94 417.675 387.487C450.209 391.86 504.14 395.537 592.319 372.119",
    fill: "url(#paint1_linear_8_55)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M592.319 372.083C626.673 365.639 663.186 372.904 684.976 381.007C697.861 386.166 752.792 406.924 788.878 455.724L843.612 415.885L661.239 278.648C624.861 251.273 592.393 219.059 564.734 182.898L427.133 3L252.704 227.898C263.804 272.075 309.223 372.94 417.675 387.487C450.209 391.86 504.14 395.537 592.319 372.119",
    fill: "url(#paint2_linear_8_55)",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M592.319 372.083C626.673 365.639 663.186 372.904 684.976 381.007C697.861 386.166 752.792 406.924 788.878 455.724L843.612 415.885L661.239 278.648C624.861 251.273 592.393 219.059 564.734 182.898L427.133 3L252.704 227.898C263.804 272.075 309.223 372.94 417.675 387.487C450.209 391.86 504.14 395.537 592.319 372.119",
    fill: "url(#paint3_linear_8_55)",
    style: {
      mixBlendMode: "darken"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_iif_8_55)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 429.075L267.177 607.601L446.514 842.031L620.944 617.133C609.826 572.956 564.425 472.127 455.973 457.58C423.457 453.207 369.508 449.53 281.329 472.948C280.365 473.127 279.384 473.252 278.402 473.412C265.642 460.043 239.355 403.23 168.184 372.797C130.707 358.803 108.292 372.583 84.6632 389.325L30 429.075Z",
    fill: "#0C75F5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30 429.075L267.177 607.601L446.514 842.031L620.944 617.133C609.826 572.956 564.425 472.127 455.973 457.58C423.457 453.207 369.508 449.53 281.329 472.948C280.365 473.127 279.384 473.252 278.402 473.412C265.642 460.043 239.355 403.23 168.184 372.797C130.707 358.803 108.292 372.583 84.6632 389.325L30 429.075Z",
    fill: "url(#paint4_linear_8_55)",
    style: {
      mixBlendMode: "darken"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_df_8_55)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M281.329 473.198C246.975 479.66 210.479 472.377 188.689 464.274C175.804 459.115 120.873 438.375 84.7702 389.575L30 429.343L223.348 574.864C252.431 596.753 278.391 622.51 300.507 651.421L446.514 842.281L620.944 617.383C609.861 573.224 564.425 472.359 455.973 457.812C423.457 453.439 369.508 449.762 281.329 473.163",
    fill: "url(#paint5_linear_8_55)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M281.329 473.198C246.975 479.66 210.479 472.377 188.689 464.274C175.804 459.115 120.873 438.375 84.7702 389.575L30 429.343L223.348 574.864C252.431 596.753 278.391 622.51 300.507 651.421L446.514 842.281L620.944 617.383C609.861 573.224 564.425 472.359 455.973 457.812C423.457 453.439 369.508 449.762 281.329 473.163",
    fill: "url(#paint6_radial_8_55)",
    fillOpacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.329 473.198C246.975 479.66 210.479 472.377 188.689 464.274C175.804 459.115 120.873 438.375 84.7702 389.575L30 429.343L223.348 574.864C252.431 596.753 278.391 622.51 300.507 651.421L446.514 842.281L620.944 617.383C609.861 573.224 564.425 472.359 455.973 457.812C423.457 453.439 369.508 449.762 281.329 473.163",
    fill: "url(#paint7_linear_8_55)",
    style: {
      mixBlendMode: "darken"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_if_8_55",
    x: 250.704,
    y: 1.26761,
    width: 594.908,
    height: 487.042,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_8_55"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_8_55"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_df_8_55",
    x: 242.704,
    y: 0,
    width: 610.908,
    height: 475.724,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8_55"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8_55",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect2_foregroundBlur_8_55"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_iif_8_55",
    x: 28,
    y: 365.025,
    width: 594.944,
    height: 487.007,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_8_55"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_8_55",
    result: "effect2_innerShadow_8_55"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect3_foregroundBlur_8_55"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_df_8_55",
    x: 0,
    y: 367.575,
    width: 650.944,
    height: 512.706,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8_55"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8_55",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect2_foregroundBlur_8_55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8_55",
    x1: 725.95,
    y1: 478.014,
    x2: 608.117,
    y2: 309.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.324422,
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8_55",
    x1: 643.713,
    y1: 247.258,
    x2: 547.974,
    y2: 23.2525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00319C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0073E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8_55",
    x1: 436.891,
    y1: 3,
    x2: 439.346,
    y2: 228.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8_55",
    x1: 341.766,
    y1: 146.609,
    x2: 474.328,
    y2: 207.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0036AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764585,
    stopColor: "#466098",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8_55",
    x1: 170.54,
    y1: 414.187,
    x2: 446.097,
    y2: 643.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003BBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.620087,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8_55",
    x1: 313.535,
    y1: 646.785,
    x2: 538.841,
    y2: 458.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#013FC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056E9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_8_55",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(271.189 655.377) rotate(-40.9741) scale(296.693 387.291)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.405211,
    stopColor: "#002881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8_55",
    x1: 30,
    y1: 431.371,
    x2: 916.815,
    y2: 347.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.187526,
    stopColor: "#001C5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ccfbd90732828204fa6989c0f15638c0.svg";
export { ForwardRef as ReactComponent };